import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { StoreBaseService } from '../../common/base.service';
import { ArticleImageContent } from './models/image-content';
import { ArticleImageContentPayload } from './models/image-content-payload';
import { Observable } from 'rxjs';
import { NormalizedSingle } from '@industi/ngx-common';
import { EncodeUtil } from '../../../shared/utils/encode.util';
import { map } from 'rxjs/operators';
import { normalize } from 'normalizr';
import { Entities } from '../../entity/entities';

@Injectable({
  providedIn: 'root'
})
export class ArticleImageContentService
  extends StoreBaseService<ArticleImageContent, ArticleImageContentPayload> {

  get entityType(): string {
    return EntityTypes.articleImageContent;
  }

  get resourceName(): string {
    return 'image-content';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }

  add(locale: string, data: ArticleImageContentPayload): Observable<NormalizedSingle> {
    const url = this.getDictionaryAddPath(locale, this.resourceName);
    return this.http.post<ArticleImageContentPayload>(url, EncodeUtil.prepareMultipartFormData(data)).pipe(
      map((res: ArticleImageContent) => normalize(res, Entities[this.entityType]))
    );
  }
}
